import $ from 'jquery'

$(document).ready(initInTheNewsSlider)

function initInTheNewsSlider() {
  const sliderWrapper = $('.js-in-the-news-slider');
  
  if (sliderWrapper.length) {
    sliderWrapper.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false, // Hide arrows on mobile
          }
        }
      ],
      nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 13.356H21.8481" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/><path d="M13.2002 2L22.0001 13.3205" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/><path d="M13.2002 24.7298L22.0001 13.3916" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/></svg></button>',
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 13.3739L2.1519 13.3739" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/><path d="M10.7998 24.7299L1.99988 13.4094" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/><path d="M10.7998 2.00003L1.99988 13.3383" stroke="#3068FF" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/></svg></button>',
    });

    // Optional: Add keyboard navigation
    sliderWrapper.on('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        $(this).slick('slickPrev');
      } else if (e.key === 'ArrowRight') {
        $(this).slick('slickNext');
      }
    });

    // Pause autoplay on hover (if autoplay is enabled)
    sliderWrapper.on('mouseenter', function() {
      $(this).slick('slickPause');
    }).on('mouseleave', function() {
      $(this).slick('slickPlay');
    });
  }
} 